import { Box } from "@chakra-ui/react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { LatLonType } from "../types";
import Pin from "./pin";

export interface UserLocationPinProps {
  userLocation: LatLonType;
}
export function UserLocationPin({ userLocation }: UserLocationPinProps) {
  return (
    <Pin
      point={{
        geometry: {
          coordinates: [userLocation.lon, userLocation.lat],
        },
      }}
    >
      <Box
        as={FaMapMarkerAlt}
        h="24px"
        w="24px"
        cursor="pointer"
        color="blueGray.800"
      />
    </Pin>
  );
}
